import { useEffect, useState } from "react";
import { MonthFilter, PageHeader } from "../../components/Common";
import { ReviewGallery } from "../../components/ReviewGallery";
import { api } from "../../lib/api";

export default function DriverReviews() {
  const [month, setMonth] = useState("");
  const [reviews, setReviews] = useState([]);
  const [seenAt, setSeenAt] = useState(undefined);

  useEffect(() => {
    api.get("/reviews/unseen").then(async (r) => {
      setSeenAt(r.data.seen_at);
      if (r.data.count) {
        await api.post("/reviews/mark-seen");
        window.dispatchEvent(new Event("reviews-seen"));
      }
    });
  }, []);
  useEffect(() => { api.get("/reviews", { params: month ? { month } : {} }).then((r) => setReviews(r.data)); }, [month]);

  return (
    <div>
      <PageHeader eyebrow="Dari tamu Anda" title="Review Tamu">
        <MonthFilter value={month} onChange={setMonth} />
      </PageHeader>
      <ReviewGallery reviews={reviews} seenAt={seenAt} />
    </div>
  );
}
